import { render } from "./GtaSingle.vue?vue&type=template&id=c10741ca"
import script from "./GtaSingle.vue?vue&type=script&lang=js"
export * from "./GtaSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__